import React from "react";
import {
    Container,
    Row,
    Col
} from "reactstrap";

import {
    RiHistoryFill,
    RiBookFill,
    RiBookMarkedFill, RiArchiveFill
} from "react-icons/ri";

import withNavigateHook from "../../hooks/withNavigationHook";
import {SeoHelper} from "../../components/helpers/SeoHelper";
import Api from "../../components/helpers/Api";

class NextSteps extends React.Component {

    state = {
        lectionaries: [],
        playlists: [],
    }

    componentDidMount() {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'view_next_steps');
        }

        Api.get("/api/lectionary")
            .then(res => {
                this.setState({lectionaries: res.data});
            })
            .catch(err => {
                console.error("Failed to load lectionaries", err);
            });

        const customer = JSON.parse(sessionStorage.getItem("customer"));
        const userId = customer?.user?.id;

        if (userId) {

            Api.get(`/user/${userId}/curated-playlist?maxRows=2`)
                .then(res => {
                    this.setState({playlists: res.data});
                })
                .catch(err => {
                    console.error("Failed to load playlists", err);
                });

            Api.get(`/user/${userId}/preferences/song-book`)
                .then(res => {
                    const preferred = res.data || [];

                    sessionStorage.setItem(
                        "preferred-song-books",
                        JSON.stringify(preferred)
                    );

                    // ✅ If no selected song books yet, initialise them from preferred
                    if (!sessionStorage.getItem("selected-song-books")) {
                        sessionStorage.setItem(
                            "selected-song-books",
                            JSON.stringify(preferred)
                        );
                    }
                })
        }
    }

    fireAnalytics(option) {

        if (typeof window.gtag === 'function') {
            window.gtag('event', 'next_steps_choice', {
                choice: option
            });
        }

    }

    renderOption(icon, label, option, route) {

        return (
            <div
                className="twb-next-step"
                onClick={() => {
                    this.fireAnalytics(option);
                    this.props.navigation(route);
                }}
            >

                <div className="twb-next-step-icon">
                    {icon}
                </div>

                <div className="twb-next-step-text">
                    {label}
                </div>

            </div>
        )

    }

    renderRecentSongFlows() {

        if (!this.state.playlists || this.state.playlists.length === 0) {
            return null;
        }

        return (
            <>
                <div className="twb-next-step">

                    <div className="twb-next-step-icon">
                        <RiHistoryFill size={24}/>
                    </div>

                    <div className="twb-next-step-text">
                        Your last song-flows
                    </div>

                </div>

                <div className="twb-next-suboptions">

                    {this.state.playlists.map(p => (

                        <div
                            key={p.id}
                            className="twb-next-suboption twb-next-suboption-row"
                        >

                        <span className="twb-playlist-name">
                            {p.name}
                        </span>

                        </div>

                    ))}

                </div>
            </>
        )
    }

    renderLectionaries() {

        return (
            <>
                <div className="twb-next-step">

                    <div className="twb-next-step-icon">
                        <RiBookFill size={24}/>
                    </div>

                    <div className="twb-next-step-text">
                        This week's lectionary readings
                    </div>

                </div>

                <div className="twb-next-suboptions">

                    {this.state.lectionaries.map(l => (

                        <div
                            key={l.lectionary_id}
                            className="twb-next-suboption"
                            onClick={() => {

                                this.fireAnalytics("lectionary_" + l.lectionary_id);

                                // ✅ Set the same session variable used by ChooseLectionary
                                sessionStorage.setItem(
                                    "selected-lectionary",
                                    l.lectionary_name
                                );

                                // ✅ Navigate to the same next step
                                this.props.navigation("/lectionary/choose-date");

                            }}
                        >
                            {l.lectionary_name}

                        </div>

                    ))}

                </div>
            </>
        )

    }

    render() {
        const customer = JSON.parse(sessionStorage.getItem("customer"));
        const name = customer?.user?.firstName;

        return <>
            <SeoHelper
                uri = "/next-steps"
                title = "Next Steps | The Worship Bible"
                description={"Continue planning your worship service with The Worship Bible"}
            />

            <section className="section section-lg">

                <Container>

                    <Row className="justify-content-center">

                        <Col lg="8">

                            <h1 className="display-3 text-center text-primary">
                                Hi {name}, what would you like to do next?
                            </h1>

                            <p className="lead text-center text-muted mb-5">
                                Start building your next worship song-flow.
                            </p>

                            <div className="twb-next-steps">

                                {/*{this.renderRecentSongFlows()}*/}

                                {/*{this.renderOption(*/}
                                {/*    <RiLayoutGridFill size={24}/>,*/}
                                {/*    "A service template",*/}
                                {/*    "service_template",*/}
                                {/*    "/service-templates"*/}
                                {/*)}*/}

                                {this.renderLectionaries()}

                                {this.renderOption(
                                    <RiBookMarkedFill size={24}/>,
                                    "A scripture passage",
                                    "scripture",
                                    "/scripture/choose-passages"
                                )}

                                {this.renderOption(
                                    <RiArchiveFill size={24}/>,
                                    "A theme",
                                    "theme",
                                    "/themes/choose-themes"
                                )}

                            </div>

                            <p className="text-center text-muted mt-4">
                                Most people start with the lectionary readings or a scripture passage.
                            </p>

                        </Col>

                    </Row>

                </Container>

            </section>
        </>
    }
}

export default withNavigateHook(NextSteps);
